import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useChat } from "../context/ChatContext";
import { UserSearch } from "../components/UserSearch";
import { ConversationList } from "../components/ConversationList";
import { CreateGroupModal } from "../components/CreateGroupModal";
import { VerifiedBadge } from "../components/VerifiedBadge";
import { Signal, Wifi, WifiOff } from "lucide-react";

export default function HomePage() {
  const { user } = useAuth();
  const { conversations, loadingConvs, realtimeMode } = useChat();
  const navigate = useNavigate();

  if (!user) return null;

  return (
    <div className="max-w-2xl mx-auto px-4 pt-24 pb-28 q-page-enter" data-testid="home-page">
      <div className="mb-4 flex items-start justify-between gap-3">
        <div>
          <p className="q-chip">
            <Signal size={12} strokeWidth={2.4} />
            @{user.ondatag}
            {user.is_verified_business && <VerifiedBadge size={11} />}
          </p>
          <h1 className="font-display text-3xl sm:text-4xl font-bold mt-2 leading-tight">
            ¡Qué onda, <span className="q-accent-text">{user.display_name.split(" ")[0]}</span>!
          </h1>
        </div>
        <div className="flex flex-col items-end gap-2">
          <span
            className="q-chip"
            data-testid="realtime-mode"
            title={realtimeMode === "ws" ? "En tiempo real" : "Sondeo cada 3s"}
          >
            {realtimeMode === "ws" ? (
              <Wifi size={12} className="q-accent-text" />
            ) : (
              <WifiOff size={12} className="text-slate-400" />
            )}
            {realtimeMode === "ws"
              ? "Tiempo real"
              : realtimeMode === "polling"
                ? "Sondeo 3s"
                : "Conectando…"}
          </span>
          <CreateGroupModal />
        </div>
      </div>

      <div className="mb-4">
        <UserSearch onOpenConversation={(c) => navigate(`/chat/${c.id}`)} />
      </div>

      <ConversationList
        conversations={conversations}
        currentUserId={user.id}
        loading={loadingConvs}
      />
    </div>
  );
}
